import { useCallback, useEffect, useState } from "react";

import {
  applyMotionAttribute,
  applyTextScale,
  applyThemeAttribute,
  loadSettings,
  type MotionPreference,
  saveSettings,
  type ThemePreference,
  type UserSettings,
} from "./settings";

export function useSettings() {
  const [settings, setSettingsState] = useState<UserSettings>(() => loadSettings());

  useEffect(() => {
    applyThemeAttribute(settings.theme);
    applyMotionAttribute(settings.motion);
    applyTextScale(settings.textScale);
  }, [settings.theme, settings.motion, settings.textScale]);

  const updateSettings = useCallback((partial: Partial<UserSettings>) => {
    setSettingsState((prev) => {
      const next = { ...prev, ...partial };
      saveSettings(next);
      return next;
    });
  }, []);

  const setTheme = useCallback((theme: ThemePreference) => updateSettings({ theme }), [updateSettings]);
  const setMotion = useCallback((motion: MotionPreference) => updateSettings({ motion }), [updateSettings]);
  const setTextScale = useCallback((textScale: number) => updateSettings({ textScale }), [updateSettings]);

  return { settings, setTheme, setMotion, setTextScale };
}
